export const ResponsiveSpinner = ({
  height = 80,
  width = 80,
  strokeWidth,
  color = "text-icon-brand-default",
  speed = "medium",
  ...props
}: {
  height?: number;
  width?: number;
  strokeWidth?: number;
  color?: string;
  speed?: "slow" | "medium" | "fast";
} & React.HTMLAttributes<HTMLDivElement>) => {
  const minDimension = Math.min(width, height);
  const radius = (minDimension / 2) * 0.9;
  const circumference = 2 * Math.PI * radius;
  const centerX = width / 2;
  const centerY = height / 2;

  // Make stroke width relative to size if not provided
  const responsiveStrokeWidth = strokeWidth ?? Math.max(2, minDimension * 0.04);

  const speedClasses = {
    slow: "animate-spin-slow",
    medium: "animate-spin",
    fast: "animate-spin-fast",
  };

  return (
    <div
      className="relative"
      style={{ width: `${width}px`, height: `${height}px` }}
      {...props}
    >
      <svg
        className={speedClasses[speed]}
        style={{ width: `${width}px`, height: `${height}px` }}
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="xMidYMid meet"
      >
        <circle
          cx={centerX}
          cy={centerY}
          r={radius}
          stroke="currentColor"
          strokeWidth={responsiveStrokeWidth}
          strokeLinecap="round"
          fill="transparent"
          strokeDasharray={circumference * 0.75}
          className={color}
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    </div>
  );
};
